module.exports = __webpack_public_path__ + "343c9427c0ba7157e45dee44bf1d63d6.svg";